<script>

    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    export let provider = null
    export let label = true

    function onSelect() {
        dispatch('select')
    }

</script>

<!-- svelte-ignore a11y-no-onchange -->

<div class="field">
    {#if label}
        <label for="" class="label">Proveedor</label>
    {/if}
    <div class="control has-icons-left">
        <span class="icon"><i class="fas fa-truck"></i></span>
        <div class="select">
            <select bind:value={provider} on:change={onSelect} >
                <option value="">Proveedor</option>
                <option value="Estafeta">Estafeta</option>
                <option value="Estafeta+">Estafeta+</option>
                <option value="EstafetaLTL">EstafetaLTL</option>
                <option value="Redpack">Redpack</option>
                <option value="FedEx">FedEx</option>
                <option value="FedEx+">FedEx+</option>
                <option value="DHL">DHL</option>
                <option value="Sendex">Sendex</option>
                <option value="JTExpress">JTExpress</option>
                <option value="99Minutos">99Minutos</option>
                <option value="Paquetexpress">Paquetexpress</option>
                <option value="Paquetexpress+">Paquetexpress+</option>
                <option value="BigSmart">BigSmart</option>
                <option value="Dliver">Dliver</option>
                <option value="TIL">TIL</option>
                <option value="Genka">Genka</option>
            </select>
        </div>
    </div>
</div>